import React, { ReactNode } from "react"
import {
  Typography,
  useTheme,
  Box,
  ToggleButton,
  ToggleButtonProps,
} from "@mui/material"
import { deepmerge } from "@mui/utils"

interface ICategoryFilterChipProps extends ToggleButtonProps {
  Icon?: ReactNode
}

export const CategoryFilterChip: React.FC<ICategoryFilterChipProps> = ({
  children,
  Icon,
  value,
  sx = {},
  ...props
}) => {
  const theme = useTheme()
  const { styleOverrides = {} } =
    theme.components?.[`AppCategoryFilterChip`] || {}
  const { root, label, icon } = styleOverrides

  return (
    <ToggleButton sx={deepmerge(root, sx)} value={value} {...props}>
      {Icon && (
        <Box className="CategoryFilterChip-icon" sx={icon}>
          {Icon}
        </Box>
      )}
      <Typography sx={label}>{children}</Typography>
    </ToggleButton>
  )
}
